import { createTheme } from "@mui/material/styles";

export const PRIMARY = "#336676";
export const MAIN_BLUE = "#355ea5";
export const SECONDARY = "#F9F9F9";
export const LIGHT = "#73CEE7";
export const RED = "#FF0000";

const FONT_FAMILY_LATIN = "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif";
const FONT_FAMILY_ARABIC = "'Cairo', 'Tajawal', 'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif";

export const getAppFontFamily = (language = "en") =>
  language === "ar" ? FONT_FAMILY_ARABIC : FONT_FAMILY_LATIN;

export const createAppTheme = ({ direction = "ltr", language = "en" } = {}) => {
  const fontFamily = getAppFontFamily(language);

  return createTheme({
    direction,
    palette: {
      primary: {
        main: PRIMARY,
      },
      secondary: {
        main: SECONDARY,
      },
      main_blue: {
        main: MAIN_BLUE,
        contrastText: "#fff",
      },
      light: {
        main: LIGHT,
      },
      red: {
        main: RED,
      },
    },
    typography: {
      fontFamily,
      h1: { fontWeight: 700, fontSize: "2.25rem" },
      h2: { fontWeight: 600, fontSize: "1.75rem" },
      h3: { fontWeight: 600 },
      body1: { fontWeight: 400, fontSize: "0.95rem" },
      button: {
        textTransform: "none",
        fontWeight: 600,
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: `
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Cairo:wght@400;500;600;700&display=swap');
          html {
            direction: ${direction};
          }
          body {
            font-family: ${fontFamily};
            background-color: #fdfdfd;
            color: #222;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
          }
        `,
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            fontFamily,
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontFamily,
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            fontFamily,
          },
        },
      },
    },
  });
};

export default createAppTheme;
